// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gG","advertCardNum":"c-a_gH"};